module.exports = __webpack_public_path__ + "static/media/exclamation.dde7c324.svg";